var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('upperMasterLowerSlave',{ref:"columnTables",attrs:{"zbParams":{
      opId: 6100000098,
      dataClass: 1,
      tableHeight: 500,
      filterObj: _vm.filterObj
    },"cbParams":{
      opId: 6100000098,
      dataClass: 2,
      tableHeight: 400,
      searchHidden: true,
      topButtonArea: _vm.topButtonVisible
    },"zcbGlgx":{
      parProp: 'RCVMSTID',
      chilProp: 'RCVMSTID'
    }},on:{"master-data-loaded":_vm.getMsterTableData,"slave-data-loaded":_vm.getSlaveTableData,"row-click":_vm.onRowClick,"first-row":_vm.onFirstRow}},[_c('template',{slot:"RIGHT_BUTTON"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.clearFilter}},[_vm._v("清除合同管理筛选")])],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }